<template>
  <div class="notfound-page">
    <div>
      <div class="num">404</div>
      <div class="text">Not found</div>
      <div class="desc">The page you are looking for is not found</div>
    </div>
  </div>
</template>
